import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import styled, { css } from 'styled-components';

import { Card, Text, Heading, Flex, Box, Icon } from 'core/components';
import PlanCardContainer from './v2/layout/PlanCardContainer';
import { PlanCardLeftFlex, PlanCardMainContentWrapper, PlanIconBox } from './v2/layout';

const FeatureWrapper = styled(Card)`
  background: ${(props) => props.theme.colors.subnavBackground};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 8px;
  margin-right: 12px;
  margin-bottom: 8px;
  flex: 1;

  ${(props) =>
    !props.active &&
    css`
      div,
      span {
        filter: grayscale(1);
        opacity: 0.65;
      }
    `}
`;

// TODO: Delete this Component When License Page Redesign is released to Production
// https://kentik.atlassian.net/browse/CORE-132
@inject('$auth')
@observer
class ServiceProviderPlanCard extends Component {
  render() {
    const { $auth, ...rest } = this.props;

    return (
      <PlanCardContainer {...rest}>
        <PlanCardLeftFlex>
          <PlanIconBox>
            <Icon icon="heatmap" iconSize={40} color="warning" />
          </PlanIconBox>

          <PlanCardMainContentWrapper>
            <Heading level={4} mb={1}>
              Service Provider
            </Heading>

            <Flex>
              <FeatureWrapper active={$auth.hasPermission('ott.enabled')}>
                <Box>
                  <Text as="div" fontSize="small" fontWeight="bold">
                    OTT Service Tracking
                  </Text>
                  <Text color="muted" fontSize="small">
                    {$auth.hasPermission('ott.enabled') ? 'Enabled' : 'Disabled'}
                  </Text>
                </Box>
              </FeatureWrapper>
              <FeatureWrapper active={$auth.hasPermission('cdn.enabled')}>
                <Box>
                  <Text as="div" fontSize="small" fontWeight="bold">
                    CDN Analytics
                  </Text>
                  <Text color="muted" fontSize="small">
                    {$auth.hasPermission('cdn.enabled') ? 'Enabled' : 'Disabled'}
                  </Text>
                </Box>
              </FeatureWrapper>
              <FeatureWrapper active={$auth.hasPermission('marketIntel.enabled')}>
                <Box>
                  <Text as="div" fontSize="small" fontWeight="bold">
                    Market Intelligence
                  </Text>
                  <Text color="muted" fontSize="small">
                    {$auth.hasPermission('marketIntel.enabled') ? 'Enabled' : 'Disabled'}
                  </Text>
                </Box>
              </FeatureWrapper>
            </Flex>
          </PlanCardMainContentWrapper>
        </PlanCardLeftFlex>
      </PlanCardContainer>
    );
  }
}

export default ServiceProviderPlanCard;
